import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DetailedQuote } from '../../../../domain/public-api';
import { IconArrowComponent } from '../../../../components/icon/icon-arrow.component';
import { NumberPipe } from '../../../../pipes/number.pipe';
import { PercentPipe } from '../../../../pipes/percent.pipe';
import { CurrencyPipe } from '../../../../pipes/currency.pipe';
import { QuoteIssueType } from '../domain';

@Component({
  selector: 'td-wb-todays-change',
  templateUrl: 'todays-change.component.html',
  styleUrls: ['todays-change.component.scss'],
  imports: [
    IconArrowComponent,
    NgClass,
    NumberPipe,
    CurrencyPipe,
    PercentPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TodaysChangeComponent {
  @Input() quote: DetailedQuote;

  /**
   * Return true if dollar change is not 0
   *
   * @returns
   */
  hasDollarChanged(): boolean {
    return this.quote.dollarChange !== undefined
      && this.quote.dollarChange !== 0;
  }

  /**
   * Return true if dollar change is greater than 0
   *
   * @returns
   */
  hasDollarChangedUp(): boolean {
    return this.quote.dollarChange > 0;
  }

  /**
   * Return true if dollar change is less than 0
   *
   * @returns
   */
  hasDollarChangedDown(): boolean {
    return this.quote.dollarChange < 0;
  }

  /**
   * Return true if issue type is 'INDEX'
   *
   * @returns
   */
  isIssueTypeIndex(): boolean {
    return this.quote.issueType === QuoteIssueType.INDEX;
  }

  /**
   * Return true if last price is 1 or more
   *
   * @returns
   */
  isLastPriceOneOrMore(): boolean {
    return this.quote.lastPrice >= 1.00;
  }
}
